import { AssetType } from "./assets"

export class Widget {
  id: string = AssetType.Chat // will be replaced with DB id
  type: AssetType = AssetType.Chat
  active?: boolean

  constructor (assetType: AssetType) {
    this.type = assetType
  }
}
